module.exports = __webpack_public_path__ + "img/settings-other.5b737562.svg";